import React from "react"
import {useTranslation} from "react-i18next"

// Components
import Icon from "../../../../../components/modern/Icon"
import ModernDialog from "../../../../../components/modern/ModernDialog"
import ModernButton from "../../../../../components/modern/ModernButton"

// Styles
import useStyles from "./styles"

type ModernBackButtonProps = {
    confirm: boolean
    onBack(): void
}

export default function ModernBackButton(props: ModernBackButtonProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");
    const {confirm, onBack} = props;

    const [asking, setAsking] = React.useState(false);

    const close = React.useCallback(() => setAsking(false), []);

    function handleClick() {
        if (confirm) {
            setAsking(true);

            return
        }

        onBack()
    }

    return (
        <React.Fragment>
            <button
                type="button"
                className={styles.btn}
                onClick={handleClick}
                title={t("back")}
                aria-label={t("back")}
            >
                <Icon name="back"/>
                <span className={styles.label}>{t("back")}</span>
            </button>

            <ModernDialog
                open={asking}
                title={t("are_you_sure")}
                onClose={close}
                actions={
                    <React.Fragment>
                        <ModernButton onClick={close}>{t("cancel")}</ModernButton>
                        <ModernButton variant="primary" onClick={onBack}>{t("back")}</ModernButton>
                    </React.Fragment>
                }
            >
                <span className={styles.note}>{t("modern.back_note")}</span>
            </ModernDialog>
        </React.Fragment>
    )
}
